<style>
#inspectionCardModal .v--modal-box.v--modal {
  min-height: 340px !important;
  min-width: 440px !important;
}
#inspectionCardModal .v-tabs__div:not(:last-child) {
  padding-right: 5px;
}
#inspectionCardModal .v-tabs__div {
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
#inspectionCardModal .v-select__selection {
  font-size: 12px !important;
}
#inspectionCardModal .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
</style>

<template>
  <Modal
    modalName="inspectionCardModal"
    :title="`KARTA PRZEGLĄDU HYDRANTU ID ${inspectionData.id}`"
    :module="module"
    @saved='addInspectionCard()'
    @opened="getUsers(), loadAttachments()"
    @closed="closed()"
    :buttons="['print']"
    @print="print()"
    :editing="editing"
    @editingStart="startEditing()"
    @editingSave="saveEditing()"
    @editingCancel="cancelEditing()"
  >

    <div style="height: 100%;">
      <v-tabs
        color="#2a579a"
        dark
        centered
        grow
        active-class="tab--active"
        :hide-slider="true"
        height="35"
      >
        <v-tab>ATRYBUTY</v-tab>
        <v-tab-item>
          <v-card
            flat
            id="attr__wrapper"
          >
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-subheader>INFORMACJE PODSTAWOWE</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrawp
            >
              <v-flex xs5>
                <v-select
                  :items="users"
                  item-text="name"
                  item-value="id"
                  no-data-text="Brak użytkowników"
                  v-model="inspectionData.user_id"
                  :readonly="!editing"
                  label="Pracownik wykonujący przegląd"
                  :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                ></v-select>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :readonly="!editing"
                >
                  <template
                    :readonly="!editing"
                    v-slot:activator="{ on }"
                  >
                    <v-text-field
                      v-model="computedDateFormatted"
                      label="Data wykonania bieżącego przeglądu"
                      prepend-icon="event"
                      :readonly="!editing"
                      @input="inspectionData.inspection_date = parseDate(computedDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="inspectionData.inspection_date"
                    @input="dateMenu = false"
                    color="#2a579a"
                    no-title
                    :readonly="!editing"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="inspectionData.comments"
                  label="Komentarz"
                  :readonly="!editing"
                ></v-text-field>
              </v-flex>
              <v-spacer />
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-subheader>OKREŚLENIE PARAMETRÓW PRZEGLĄDU</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-list style="width: 100%">
                  <template v-for="(value, key) in parametersFields">
                    <v-list-tile
                      class="list--el"
                      style="border-bottom: 1px solid lightgrey"
                      :key="key"
                    >
                      <v-list-tile-content @click="inspectionData[key] = !inspectionData[key]">
                        <v-list-tile-title>{{value}}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-checkbox
                          class="checkbox--big"
                          :readonly="!editing"
                          v-model="inspectionData[key]"
                        ></v-checkbox>
                      </v-list-tile-action>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-subheader>POMIERZONE WARTOŚCI</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-list style="width: 100%">
                  <template v-for="(value, key) in measuredValues">
                    <v-list-tile
                      style="border-bottom: 1px solid lightgrey"
                      class="list--el"
                      :key="key"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{value}}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-text-field
                          height="16"
                          type="number"
                          placeholder="Wpisz wartość [MPa]"
                          single-line
                          class="placeholder--right"
                          v-model="inspectionData[key]"
                          hide-details
                          :readonly="!editing"
                        ></v-text-field>
                      </v-list-tile-action>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>

        <v-tab>DANE HYDRANTU</v-tab>
        <v-tab-item>
          <v-card
            flat
            v-if="hydrantData"
          >
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-subheader>DANE TECHNICZNE</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.id"
                  readonly
                  label="ID hydrantu"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.registry_exploitation"
                  readonly
                  label="Numer eksploatacyjny hydrantu"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-select
                  :items="statuses"
                  v-model="hydrantData.status"
                  label="Status"
                  readonly
                ></v-select>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-select
                  :items="hydrantKinds"
                  v-model="hydrantData.hydrant_kind"
                  label="Rodzaj hydrantu"
                  readonly
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.producer"
                  readonly
                  label="Producent"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.last_inspection_date"
                  readonly
                  label="Data wykonania ostatniego przeglądu"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-subheader>DANE ADRESOWE</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.address_place"
                  readonly
                  label="Miejscowość"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.address_street"
                  readonly
                  label="Ulica"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.address_order"
                  readonly
                  label="Numer porządkowy"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.address_plot"
                  readonly
                  label="Numer działki"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>

        <!-- No events during adding insepction - that's why (0) -->
        <v-tab v-if="events != undefined && events.hasOwnProperty('events')">ZDARZENIA ({{events.events_count}})</v-tab>
        <v-tab v-else>ZDARZENIA (0)</v-tab>
        <v-tab-item>
          <v-card flat>
            <Events
              style="margin-top: 15px"
              :featureEvents="events"
              :objectTable="objectTable"
              :id="inspectionData.id"
            />
          </v-card>
        </v-tab-item>

        <v-tab v-if="attachmentsArr.hasOwnProperty('data')">ZAŁĄCZNIKI ({{attachmentsArr.data.length}})</v-tab>
        <v-tab-item>
          <v-layout row>
            <v-flex
              xs12
              v-if="$can('read', 'inspections_attachments') || $can('edit', 'inspections_attachments')"
            >
              <v-subheader class="font--primary">Powiązane załączniki</v-subheader>
              <div v-if="ifAttachments.hasOwnProperty('data') && ifAttachments.data.length > 0">
                <li
                  class="list__container--el"
                  v-for="(index, key) in attachmentsArr.data"
                  :key="key"
                >
                  <span>{{index.id}} - {{index.filename}}</span>
                  <span>
                    <v-icon
                      @click="downloadAttachment(index.id, index.filename)"
                      small
                      title="Pobierz załącznik"
                      v-if="$can('read', 'inspections_attachments') || $can('edit', 'inspections_attachments')"
                    >cloud_download</v-icon>
                    <v-icon
                      @click="deleteAttachment(index.id)"
                      small
                      title="Usuń załącznik"
                      v-if="$can('edit', 'inspections_attachments')"
                    >delete</v-icon>
                  </span>
                </li>
              </div>
              <div v-else>
                <p class="font--primary">Brak powiązanych załączników</p>
              </div>
              <AddAttachment
                v-show="editing"
                ref="childComponentInspection"
                @attachmentAdded="loadAttachments()"
                @attachmentDeleted="loadAttachments()"
                @confDialogOpened="triggerDialogAttach"
                @fileAdded="updateList"
                @fileRemoved="updateListRemove"
                :id_="inspectionData.id"
                :objectType="objectType"
                :objectTable="objectTable"
                :auto="true"
                :module="module"
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            v-show="editing"
          >
            <v-subheader class="font--primary">ZAŁĄCZNIKI Z BAZY DANYCH</v-subheader>
          </v-layout>
          <v-layout
            row
            wrap
            style="height: 90%"
            v-show="editing"
          >
            <v-flex xs12>
              <DatabaseAttachments
                :objectIdCard="inspectionData.id"
                :objectTableCard="objectTable"
                :objectTypeCard="objectType"
                @attachmentAdded="loadAttachments"
              />
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";
import AddAttachment from "../../../../shared/AddAttachment";
import Events from "../../../../shared/Events";
import DatabaseAttachments from "../../../table/attachments/DatabaseAttachments";

export default {
  components: {
    AddAttachment,
    DatabaseAttachments,
    Modal,
    Events
  },
  data: () => ({
    attachmentsArr: [],
    dateFormatted: undefined,
    dateMenu: false,
    editing: false,
    eventsNumber: 0,
    events: {},
    hydrantData: undefined,
    hydrantKinds: [],
    inspectionData: {},
    inspectionDataCopy: {},
    measuredValues: {
      static_pressure_value: 'Wartość zmierzonego ciśnienia statycznego',
      dynamic_pressure_value: 'Wartość zmierzonego ciśnienia dynamicznego',
      flow_rate_value: 'Wartość natężenia wypływu z hydrantu'
    },
    module: "inspections",
    objectTable: "inspections",
    objectType: "inspections",
    parametersFields: {
      external_examination: 'Oględziny zewnętrzene hydrantu',
      startup: 'Uruchomienie/przepłukanie hydrantu',
      static_pressure: 'Pomiar ciśnienia statycznego',
      dynamic_pressure: 'Pomiar ciśnienia dynamicznego',
      flow_rate: 'Pomiar natężenia wypływu',
      abduction: 'Sprawdzenie skuteczności odwodnienia'
    },
    statuses: [],
    valid: false
  }),
  watch: {
    "inspectionData.inspection_date"(val) {
      if(this.dateFormatted) {
        this.dateFormatted.dateFormatted = this.formatDate(this.dateFormatted.inspection_date)
      }
    },
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    computedDateFormatted() {
      if(this.inspectionData.hasOwnProperty('inspection_date')) {
        return this.formatDate(this.inspectionData.inspection_date.slice(0, 10))
      }
    },
    featureEvents() {
      return this.$store.getters.getFeatureEvents;
    },
    ifAttachments() {
      return this.$store.getters.getObjectAttachments;
    },
    users() {
      return this.$store.getters.getUsers.map(user => {
        return {
          name: user.name,
          id: user.id
        };
      });
    }
  },
  methods: {
    cancelEditing() {
      this.editing = false;
      this.inspectionData = JSON.parse(JSON.stringify(this.inspectionDataCopy));
    },
    closed() {
      this.editing = false;
      this.hydrantData = undefined;
      this.inspectionData = {};
      this.inspectionDataCopy = {};
    },
    deleteAttachment(attachmentId) {
      this.$refs.childComponentInspection.deleteAttachment(attachmentId);
    },
    downloadAttachment(attachmentId, attachmentName) {
      this.$refs.childComponentInspection.downloadAttachment(
        attachmentId,
        attachmentName
      );
    },
    formatDate(date) {
      if(!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    getHydrantData() {
      let payload = {
        object_table: "hydrants",
        object_id: this.inspectionData.hydrant
      }
      this.$store.dispatch("getFeature", payload).then(success => {
        if(success) {
          this.hydrantData = success.values_;
          let payloadKinds = {
            schema: "aquagis",
            table: "hydrants",
            column: "hydrant_kind"
          }
          this.$store.dispatch('getDictSTC', payloadKinds).then(r => {
            this.hydrantKinds = r.values;
          })

          let payloadStatuses = {
            schema: "aquagis",
            table: "hydrants",
            column: "status"
          }
          this.$store.dispatch('getDictSTC', payloadStatuses).then(r => {
            this.statuses = r.values;
          })
        }
        else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas pobierania danych hydrantu wystąpił błąd"
          );
        }
      })
    },
    getUsers() {
      if(this.users.length < 1) {
        this.$store.dispatch("getUsers");
      }
    },
    loadAttachments() {
      let payload = {
        object_type: this.objectType,
        layer: this.objectTable,
        oid: this.inspectionData.id
      };
      this.$store
        .dispatch("getAttachmentsForObject", payload)
        .then(success => {
          if(success) {
            this.attachmentsArr = this.$store.getters.getObjectAttachments;
          }
        });
    },
    loadHydrantInspection(data) {
      this.inspectionData = data;
      this.getHydrantData();
    },
    parseDate(date) {
      if(!date) {
        return null;
      } else {
        const [day, month, year] = date.split(".");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },
    print() {
      if(!this.inspectionData.user_id) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Podanie pracownika wykonującego przegląd jest wymagane"
        );
        return;
      }
      this.$root.$emit("printReport", ['inspection', this.inspectionData.id])
    },
    saveEditing() {
      delete this.inspectionData.username
      let payload = {
        body: JSON.parse(JSON.stringify(this.inspectionData)),
        id: this.inspectionData.id
      };
      this.$store.dispatch("editInspectionCard", payload).then(r => {
        if(r) {
          this.editing = false;
          this.$root.$emit('edited_inspection')
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            `${r}`
          );
        }
      });
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    startEditing() {
      this.editing = true;
      this.inspectionDataCopy = JSON.parse(JSON.stringify(this.inspectionData));
    },
    setInspection(data) {
      this.events = data;
    },
    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    },
    updateList() {
      this.attachmentsNumber = this.$refs.childComponentInspection.$refs.attachmentDropzone.getQueuedFiles().length + 1;
    },
    updateListRemove() {
      this.attachmentsNumber = this.$refs.childComponentInspection.$refs.attachmentDropzone.getQueuedFiles().length;
    }
  },
  mounted() {
    // this.$root.$on("completeInspection", this.getHydrantData);
    this.$root.$on("loadHydrantInspection", this.loadHydrantInspection);
    this.$root.$on("loadAttachments", this.loadAttachments);
    this.$root.$on("setInspection", this.setInspection);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/hydrants/modals/inspections/InspectionCard.vue